module.exports = Object.freeze({
    ColumnStatus: {
        Neither: {name: 'neither', id: 0},
        UnfilledMandatory: {name: 'unfilledMandatory', id: 1},
        WrongDataFormat: {name: 'wrongDataFormat', id: 2}, 
        Unfilled: {name: 'unfilled', id: 3},
        Filled: {name: 'filled', id: 4},
    }
});